__turbopack_context__.v({
  "container": "AppWrapper-module__-bQd0G__container",
  "content": "AppWrapper-module__-bQd0G__content",
  "logged": "AppWrapper-module__-bQd0G__logged",
  "sidebarIsClosed": "AppWrapper-module__-bQd0G__sidebarIsClosed",
  "sidebarLayout": "AppWrapper-module__-bQd0G__sidebarLayout",
});
